module.exports = __webpack_public_path__ + "static/img/Platform_design2.b2164b4.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/Platform_design2.png
// module id = sbR5
// module chunks = 0